import { useCallback, useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";

export function useSharedEvaluations({ accessToken, evalApi, onAfterClone }) {
  const { t } = useTranslation("therapist");
  const [sharedOpen, setSharedOpen] = useState(false);
  const [sharedLoading, setSharedLoading] = useState(false);
  const [sharedEvals, setSharedEvals] = useState([]);

  const openShared = useCallback(async () => {
    if (!accessToken) return;

    setSharedOpen(true);
    setSharedLoading(true);

    try {
      const { evaluations } = await evalApi.getSharedEvaluations(accessToken, {
        page: 1,
        limit: 12,
      });
      setSharedEvals(evaluations || []);
    } catch (e) {
      console.error(e);
      message.error(
        e?.message || t("evaluaciones.avisos.errorCargarCompartidas"),
      );
      setSharedEvals([]);
    } finally {
      setSharedLoading(false);
    }
  }, [accessToken, evalApi, t]);

  const closeShared = useCallback(() => setSharedOpen(false), []);

  const onClone = useCallback(
    async (ev) => {
      if (!accessToken || !ev?._id) return;

      try {
        await evalApi.cloneEvaluation(accessToken, ev._id);
        message.success(t("evaluaciones.avisos.clonada"));
        await onAfterClone?.();
      } catch (e) {
        console.error(e);
        message.error(e?.message || t("evaluaciones.avisos.errorClonar"));
      }
    },
    [accessToken, evalApi, onAfterClone, t],
  );

  return {
    sharedOpen,
    sharedLoading,
    sharedEvals,
    openShared,
    closeShared,
    onClone,
  };
}
